import {AppBar, Grid, Tab, Tabs, withStyles,} from "@material-ui/core";
import {format} from "date-fns";
import React from "react";
import {useParams} from "react-router-dom";
import DefaultQueryHandler from "../../common/DefaultQueryHandler";
import {hasRole, HasRole, useTabIndex,} from "../../common/Util";
import Page from "../../components/Page";
import {
    DepositStatus,
    InvoiceStatus,
    OrderItemStatus,
    RoleIdEnum,
    useGetCurrentUserQuery,
    useGetOrderItemQuery,
    useRemoveAllDepositMutation,
    useUpdateOrderItemMutation,
} from "../../generated/graphql";
import DetailView from "../custom/DetailView";
import TabPanel from "../custom/TabPanel";
import CreateDeposit from "../deposit/CreateDeposit";
import DepositTable from "../deposit/OrderItemDepositTable";
import UpdateOrderItem from "./UpdateOrderItem";
import ConfirmButton from "../../components/ConfirmButton";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import {BelongingMap, OrderItemTypeMap, OrderStatusMap} from "../../common/Constant";
import UploadDepositButton from "../deposit/UploadDepositButton";
import OrderItemPurchaseOrderTable from "../purchaseOrder/OrderItemPurchaseOrderTable";
import CreatePurchaseOrder from "../purchaseOrder/CreatePurchaseOrder";
import {FieldTagMap, ProductTagMap} from "../../common/IndustryConstant";

var orderItemColumns = [
    {
        field: "order",
        headerName: "專案名稱",
    },
    { field: "id", headerName: "ID" },
    {
        field: "status",
        headerName: "狀態",
        valueFormatter: (value) => {
            return OrderStatusMap[value];
        },
    },
    { field: "product", headerName: "產品" },
    {
        field: "type",
        headerName: "操作方式",
        valueFormatter: (type) => (type ? OrderItemTypeMap[type] : "未指定"),
    },
    {
        field: "totalAmount",
        headerName: "購買金額",
        valueFormatter: (value) => value?.toLocaleString(),
    },
    {
        field: "serviceFee",
        headerName: "帳戶執行費",
        valueFormatter: (value) => value?.toLocaleString(),
    },
    {
        field: "budget",
        headerName: "成本預算",
        valueFormatter: (value) => value?.toLocaleString(),
    },
    {
        field: "assignee",
        headerName: "專案負責人",
        valueFormatter: (value) => (value ? value.name : "未指派"),
    },
    {
        field: "supporter",
        headerName: "專案執行人",
        valueFormatter: (value) => (value ? value.name : "未指派"),
    },
    {
        field: "startDate",
        headerName: "開始時間",
        valueFormatter: (value) => format(new Date(value), "yyyy-MM-dd"),
    },
    {
        field: "endDate",
        headerName: "結束時間",
        valueFormatter: (value) => format(new Date(value), "yyyy-MM-dd"),
    },
    {
        field: "description",
        headerName: "備註",
    },
    {
        field: "productTag",
        headerName: "產品標籤",
        valueFormatter: (value) => ProductTagMap[value],
    },
    {
        field: "fieldTag",
        headerName: "場域標籤",
        valueFormatter: (value) => FieldTagMap[value],
    },
    {
        field: "belonging",
        headerName: "業績歸屬",
        valueFormatter: (value) => BelongingMap[value],
    }
];

const canFinish = (orderItem, depositTotal, priviledge) => {
    if (orderItem.status == OrderItemStatus.Started) {
        if (priviledge) {
            return true;
        }
        // check endDate
        if (new Date(orderItem.endDate) < new Date()) {
            // check deposits
            if (depositTotal <= 0) {
                // check invoices
                let invoiceAmount = 0;
                orderItem.order.invoices.map((invoice) => {
                    invoice.items.map((invoiceItem) => {
                        if (invoice.status == InvoiceStatus.Posted || invoice.status == InvoiceStatus.Paid) {
                            if (invoiceItem.orderItem.id == orderItem.id) {
                                invoiceAmount += invoiceItem.amount;
                            }
                        }
                    });
                });
                if (
                    invoiceAmount >= orderItem.totalAmount + orderItem.serviceFee
                ) {
                    return true;
                }
            }
        }
    }
    return false;
};
const canGetBonus = (orderItem) => {
    if (orderItem.status == OrderItemStatus.Finished) {
        let invoiceAmount = 0;
        orderItem.order.invoices.map((invoice) => {
            invoice.items.map((invoiceItem) => {
                if (invoice.status == InvoiceStatus.Paid) {
                    if (invoiceItem.orderItem.id == orderItem.id) {
                        invoiceAmount += invoiceItem.amount;
                    }
                }
            });
        });
        if ( invoiceAmount >= orderItem.totalAmount + orderItem.serviceFee ) {
            return true;
        }
    }
    return false;
};

export default () => {
    const meQuery = useGetCurrentUserQuery();
    const { id } = useParams();
    const { data, loading, error } = useGetOrderItemQuery({
        variables: {
            id,
        },
    });
    const [tabIndex, setTabIndex] = useTabIndex();
    const [updateOrderItem] = useUpdateOrderItemMutation({
        refetchQueries: ["getOrderItem"],
    });
    const [removeAllDeposits] = useRemoveAllDepositMutation();

    let total = data?.orderItem?.budget ?? 0;
    data?.orderItem?.deposits.map((deposit:any) => {
        if (deposit.status == DepositStatus.Finished) {
            total -= deposit.amount;
        }
        else if ([DepositStatus.Pending, DepositStatus.Changed].includes(deposit.status)) {
            if (deposit.changes.length > 0) {
                const lastVerifiedRecord = deposit.changes
                    ?.filter(record => record.verified)
                    .sort((a, b) => b.id - a.id)[0];
                total -= Math.max(deposit.changes[deposit.changes.length - 1].amount, lastVerifiedRecord?.amount ?? 0);
                console.log(Math.max(deposit.changes[deposit.changes.length - 1].amount, lastVerifiedRecord?.amount ?? 0));
            }
        }
    });

    const AccordionSummary = withStyles({
        content: {
            alignItems: "center",
        },
    })(MuiAccordionSummary);

    const changeStatus = async (status) => {
        await updateOrderItem({
            variables: {
                id,
                orderItem: {
                    status,
                },
            },
            refetchQueries: ["getOrderItem"],
        });
        // check all order items status
    };
    const removeAllDeposit = async () => {
        await removeAllDeposits(
            {
                variables: {id},
                refetchQueries: ["getOrderItem", "getDepositList"]
            });
    }

    let priviledge = false;
    meQuery.data?.me.roles.map((role) => {
        console.log(role);
        if (["admin", "finance"].indexOf(role.id) != -1) {
            console.log(role.id);
            priviledge = true;
        }
    });


    return (
        <Page title={"Order item detail page"}>
            <AppBar position="static" color="default">
                <Tabs
                    value={tabIndex}
                    indicatorColor="secondary"
                    textColor="secondary"
                    onChange={(
                        event: React.ChangeEvent<{}>,
                        newValue: number
                    ) => {
                        setTabIndex(newValue);
                    }}
                >
                    <Tab label="委刊細項" />
                    {hasRole(meQuery.data?.me, [RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.PmManager, RoleIdEnum.Gm, RoleIdEnum.Coo, RoleIdEnum.Finance, RoleIdEnum.Op, RoleIdEnum.Secretary]) && <Tab label="發稿" />}
                    {hasRole(meQuery.data?.me, [RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.PmManager, RoleIdEnum.Gm, RoleIdEnum.Coo, RoleIdEnum.Finance, RoleIdEnum.Op, RoleIdEnum.Secretary]) && <Tab label="付款單" />}
                </Tabs>
            </AppBar>
            <DefaultQueryHandler loading={loading} error={error}>
                <TabPanel value={tabIndex} index={0}>
                    <Grid container spacing={3}>
                        <Grid item>
                            <UpdateOrderItem orderItem={data?.orderItem} />
                        </Grid>
                        {data && canFinish(data?.orderItem, total, priviledge) && (
                            <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.AeManager, RoleIdEnum.PmManager, RoleIdEnum.Gm, RoleIdEnum.Finance, RoleIdEnum.Secretary]}>
                            <Grid item>
                                <ConfirmButton
                                    onConfirm={async () => {
                                        await changeStatus(OrderItemStatus.Finished);
                                    }}
                                    queryEntity={"orderItem"}
                                    queryAction={"結案"}
                                    entityId={id}
                                >
                                    結案
                                </ConfirmButton>
                            </Grid>
                            </HasRole>
                        )}
                        {(data?.orderItem?.status == OrderItemStatus.Finished) && (
                            <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.AeManager, RoleIdEnum.PmManager, RoleIdEnum.Gm, RoleIdEnum.Finance, RoleIdEnum.Secretary]}>
                            <Grid item>
                                <ConfirmButton
                                    onConfirm={async () => {
                                        await changeStatus(OrderItemStatus.Started);
                                    }}
                                    queryEntity={"orderItem"}
                                    queryAction={"取消結案"}
                                    entityId={id}
                                >
                                    取消結案
                                </ConfirmButton>
                            </Grid>
                            </HasRole>
                        )}
                        <HasRole
                            roles={[
                                RoleIdEnum.Admin,
                                RoleIdEnum.Gm,
                                RoleIdEnum.Finance,
                            ]}
                        >
                            <Grid item>
                                {data && canGetBonus(data?.orderItem) && (
                                        <ConfirmButton
                                            onConfirm={() => {
                                                changeStatus(
                                                    OrderItemStatus.BonusAssigned
                                                );
                                            }}
                                            queryEntity={"orderItem"}
                                            queryAction={"發獎金"}
                                            entityId={id}
                                        >
                                            發獎金
                                        </ConfirmButton>
                                    )}
                            </Grid>
                        </HasRole>
                    </Grid>
                    <DetailView
                        data={data?.orderItem}
                        columns={orderItemColumns}
                    />
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                    {data?.orderItem?.order.customer.invoiceExpired
                        ? <b style={{color:"red"}}>此客戶有逾期發票，因此無法發稿，請聯絡財務。</b>
                    : <Grid container spacing={3}>
                        {data?.orderItem?.status != OrderItemStatus.Finished && <Grid item>
                            <CreateDeposit orderItem={data?.orderItem} />
                        </Grid>}
                        {data?.orderItem?.status != OrderItemStatus.Finished &&<Grid item>
                            <UploadDepositButton orderItem={data?.orderItem} />
                        </Grid>}
                        <Grid item>
                            <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance, RoleIdEnum.Op]}>
                                <ConfirmButton
                                    onConfirm={()=>removeAllDeposit()}
                                    queryEntity={"orderItem"}
                                    queryAction={"刪除所有發稿"}
                                    entityId={id}
                                >刪除所有發稿</ConfirmButton>
                            </HasRole>
                        </Grid>
                    </Grid>}
                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                        發稿可用金額：{total.toLocaleString()}
                    </div>
                    <DepositTable orderItem={data?.orderItem} />
                </TabPanel>
                <TabPanel value={tabIndex} index={2}>
                    <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.Op, RoleIdEnum.Secretary]}>
                    <CreatePurchaseOrder orderItem={data?.orderItem} />
                    </HasRole>
                    <br/>
                    <OrderItemPurchaseOrderTable orderItem={data?.orderItem} />
                </TabPanel>
            </DefaultQueryHandler>
        </Page>
    );
};
